import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-user-edit-stock-program',
  templateUrl: './user-edit-stock-program.component.html',
  styleUrls: ['./user-edit-stock-program.component.css']
})
export class UserEditStockProgramComponent implements OnInit {

  programOrderGuid: string | undefined

  loading: boolean = false;


  constructor(
      private _router: Router,
      private _messageService: MessageService,
      public translateService: TranslateService,
      private _activatedRoute: ActivatedRoute,
      public translate: TranslateService,
  ){
      this._activatedRoute.params.subscribe(params => {
      this.programOrderGuid = params['programOrderGuid']
    })
  }

  ngOnInit(): void {

  }

}
